import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import SelectWithCheckboxesRedesign from "../../redesign/elements/Select/SelectWithCheckboxesRedesign";
import { PrimaryButton } from "../../redesign/elements/Button";
import { SelectOptionType } from "../../elements/Select/Select";

type HubSpotSelectorRedesignProps = {
  label: string;
  value: string[] | number[];
  options: SelectOptionType[];
  buttonLabel: string;
  onButtonClick: () => void;
  onChange: (e: any) => void;
  disabled?: boolean;

  isChecked?: boolean;
  checkboxLabel?: string;
  onCheckboxChange?: (event: React.ChangeEvent<{}>, checked: boolean) => void;
};

const Root = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  marginTop: 8,
  marginBottom: 8,
  maxWidth: 449,
  width: "100%",
});

const CheckboxLabel = styled(FormControlLabel)(({ theme }: { theme: Theme }) => ({
  margin: 0,
  "& .MuiFormControlLabel-label": {
    fontSize: 13,
    color: theme.palette.brand.gray700,
  },
}));

const HubSpotSelectorRedesign: FC<HubSpotSelectorRedesignProps> = ({
  label,
  value,
  options,
  onButtonClick,
  onChange,
  buttonLabel,
  disabled,
  isChecked,
  checkboxLabel,
  onCheckboxChange,
}) => (
  <Root>
    <SelectWithCheckboxesRedesign label={label} options={options} value={value} onChange={onChange} />

    <PrimaryButton type="button" onClick={onButtonClick} disabled={disabled}>
      {buttonLabel}
    </PrimaryButton>

    {onCheckboxChange && checkboxLabel && (
      <CheckboxLabel
        control={
          <Checkbox
            color="primary"
            size="small"
            checked={isChecked}
            onChange={(event, checked) => onCheckboxChange(event, checked)}
          />
        }
        label={checkboxLabel}
      />
    )}
  </Root>
);

export default HubSpotSelectorRedesign;
